import React, { useState } from 'react';
import { Box, Button, Card, CardContent, TextField } from '@mui/material';
import ReactSelect from 'react-select';
import { translate as t } from 'hooks/useTranslations';
import { Close } from '@mui/icons-material';
import { CRQChoice, CRQChoiceContent } from 'views/App/Portal/Policy/_types/crq';
import { ManualContent } from 'views/App/Portal/Policy/_types/manuals/draft';

type ChoiceProps = {
  choice: CRQChoice;
  manualContent: ManualContent[];
  handleItemChange: (choice: CRQChoice) => void;
  handleRemoveItem: () => void;
};

const Choice = ({ choice, handleItemChange, handleRemoveItem, manualContent }: ChoiceProps) => {
  const contentOptions = manualContent.map((x) => {
    return { value: x.contentUri, label: x.title };
  });
  const [value, setValue] = useState<string>(choice.value);
  const [content, setContent] = useState<string[]>((choice.content ?? []).map((x) => x.contentUri));

  const handleValueChange = (newValue: string) => {
    setValue(newValue);
    handleItemChange({ ...choice, value: newValue });
  };

  const handleContentChange = (newContent: string[]) => {
    setContent(newContent);
    handleItemChange({ ...choice, content: newContent.map((x) => ({ contentUri: x }) as CRQChoiceContent) });
  };

  return (
    <Card>
      <CardContent>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr auto',
            gap: 2,
            alignItems: 'center',
          }}
        >
          <TextField
            label={false}
            fullWidth
            value={value ?? ''}
            onChange={(e) => handleValueChange(e.target.value)}
            sx={{ pt: 0, '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
          />
          <Button
            className='icon-only'
            variant='text'
            color='neutral'
            onClick={() => handleRemoveItem()}
          >
            <Close />
          </Button>
          <ReactSelect
            key={choice.value}
            name='content'
            defaultValue={contentOptions.filter((x) => content.includes(x.value))}
            options={contentOptions}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            menuPosition='fixed'
            menuPlacement='auto'
            isMulti
            isSearchable
            onChange={(newValue) => handleContentChange(newValue.map((x) => x.value))}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default Choice;
